import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-8" }
const _hoisted_65 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_66 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill fs-6" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create"
}, null, -1)
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "form-text" }
const _hoisted_72 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_73 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_74 = { class: "indicator-label" }
const _hoisted_75 = { class: "indicator-progress" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'users'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateOffice')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.officeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('name')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "name",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('officeName'),
                      modelValue: _ctx.office?.name,
                      disabled: ""
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "name" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('email')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "email",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('email'),
                      modelValue: _ctx.office?.email
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "email" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('phone')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "phone",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('phone'),
                      modelValue: _ctx.office?.phone
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "phone" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('website')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "website",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('website'),
                      modelValue: _ctx.office?.business_account_info?.website
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "website" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('facebook')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "facebook",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('facebook'),
                      modelValue: _ctx.office?.business_account_info?.facebook
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_ErrorMessage, { name: "facebook" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('whatsapp')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "whatsapp",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('whatsapp'),
                      modelValue: _ctx.office?.business_account_info?.whatsapp
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "whatsapp" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.translate('instagram')), 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "instagram",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('instagram'),
                      modelValue: _ctx.office?.business_account_info?.instagram
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_ErrorMessage, { name: "instagram" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('twitter')), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "twitter",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('twitter'),
                      modelValue: _ctx.office?.business_account_info?.twitter
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "twitter" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.translate('registrationNumber')), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "registrationNumber",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('registrationNumber'),
                      modelValue: _ctx.office?.business_account_info?.registrationNumber
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ErrorMessage, { name: "registrationNumber" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('registrationExpiryDate')), 1),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "registrationExpiryDate",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('registrationExpiryDate'),
                      modelValue: 
                  _ctx.office?.business_account_info?.registrationExpiryDate
                
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_ErrorMessage, { name: "registrationExpiryDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('additionalInfo')), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createVNode(_component_Field, {
                      type: "textarea",
                      name: "additionalInfo",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('additionalInfo'),
                      modelValue: _ctx.office?.business_account_info?.about
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_ErrorMessage, { name: "additionalInfo" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.translate('logo')), 1),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_66, [
                        _hoisted_67,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "logo",
                          accept: ".png, .jpg, .jpeg",
                          onChange: _ctx.previewImage
                        }, null, 8, ["onChange"]),
                        _hoisted_68
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_ErrorMessage, { name: "logo" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.translate('allowedFileTypes')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                (_ctx.office?.member_type === 2 && _ctx.office.isOwner)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger me-auto",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onConvertOfficeToIndividual && _ctx.onConvertOfficeToIndividual(...args)))
                    }, _toDisplayString(_ctx.translate('convertOfficeToIndividual')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_73, [
                  _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_75, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_76
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}